module.exports = __webpack_public_path__ + "img/success_avatar.dee8f94e.svg";